var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-row',[_c('v-col',{attrs:{"cols":"12"}},[(_vm.image)?_c('center',[_c('v-img',{attrs:{"src":_vm.image,"max-width":"320px"}})],1):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }